export const defaultSettingType = {
    UPDATE_DEFAULT_SETTING: "UPDATE_DEFAULT_SETTING",

    ON_CHANGE_LANGUAGE: "ON_CHANGE_LANGUAGE",

    ON_SUCCESS: "ON_SUCCESS",

    UPDATE_GO_BACK: "UPDATE_GO_BACK",

    UPDATE_SHOW_GO_BACK_MODAL: "UPDATE_SHOW_GO_BACK_MODAL",

    RESET:"RESET"
}